import {PaymentStatus} from "./wspay-confirmation";

export class WspayResult {
  constructor(
    private cartId: string,
    private signature: string,
    private wsPayStatus: PaymentStatus,
    private approvalCode?: string,
    private errorMsg?: string) {
  }
}
